var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('link',{attrs:{"rel":"stylesheet","href":("https://fonts.googleapis.com/css?family=" + _vm.url)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }